import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Selects from "../Selects";
import firebase from "firebase/app";
import "firebase/storage";
import "firebase/database";
import "./css.css";
import Compress from "compress.js";

export default function AddProduct(props) {
  const compress = new Compress();

  const [cantImg, setCantImg] = useState(null);

  const [category, setCategory] = useState("t-shirt");
  const handleChangeCategory = (e) => {
    setCategory(e.target.value);
  };

  const [sizes, setSizes] = useState([]);
  const handleChangeSizes = (e) => {
    var value = [];
    var options = e.target.options;
    for (var i = 0, l = options.length; i < l; i++) {
      if (options[i].selected) {
        value.push(options[i].value);
      }
    }
    setSizes(value);
  };

  const [name, setName] = useState("");
  const handleChangeName = (e) => {
    setName(e.target.value);
  };

  const [mainImg, setMainImg] = useState(0);

  const [price, setPrice] = useState(0);
  const handleChangePrice = (e) => {
    if (!isNaN(e.target.value.slice(-1)));
    setPrice(e.target.value);
  };

  const [img, setImg] = useState([]);
  const handleChangeImage = (e) => {
    const file = [...e.target.files];
    compress
      .compress(file, {
        size: 2, // the max size in MB, defaults to 2MB
        quality: 1, // the quality of the image, max is 1,
        maxWidth: 1000, // the max width of the output image, defaults to 1920px
        maxHeight: 1000, // the max height of the output image, defaults to 1920px
        resize: true, // defaults to true, set false if you do not want to resize the image width and height
      })
      .then((data) => {
        var newImgs = [...img];
        data &&
          data.forEach((img) => {
            const img1 = img;
            const base64str = img1.data;
            const imgExt = img1.ext;
            const file = Compress.convertBase64ToFile(base64str, imgExt);
            newImgs.push({ url: URL.createObjectURL(file), image: file });
          });
        setImg(newImgs);
      });
  };

  const [idBD, setIDBD] = useState("");
  const [loading, setLoading] = useState("loading");

  const defaultProps = () => {
    setCategory("t-shirt");
    setSizes([]);
    setImg([]);
    setPrice(0);
  };

  useEffect(() => {
    if (props.match.params.id) {
      if (isNaN(props.match.params.id)) {
        alert("Producto inválido.");
        setLoading("error");
      } else {
        const getProduct = async () => {
          setLoading("loading");
          const db = firebase.database().ref("/products");
          const obj = (
            await db
              .orderByChild("_id")
              .equalTo(parseInt(props.match.params.id))
              .once("value")
          ).val();
          if (obj !== null) {
            setIDBD(Object.getOwnPropertyNames(obj)[0]);
            const product = obj[Object.getOwnPropertyNames(obj)[0]];
            setCategory(product.category);
            setSizes(product.sizes);
            getImgs(product._id, product.cantImg, product.img);
            setCantImg(product.cantImg);
            setPrice(product.price);
            if (product.name) setName(product.name);
            setLoading("");
          } else {
            setLoading("error");
          }
        };
        getProduct();
      }
    } else {
      defaultProps();
      setLoading("");
    }
  }, [props.match.params]);

  const getImgs = async (id, cantImg, urlMain) => {
    var newImgs = [];
    for (var i = 0; i < cantImg; i++) {
      try {
        const img = await firebase
          .storage()
          .ref(`pics/${id}`)
          .child(`${i}`)
          .getDownloadURL();
        newImgs.push({ url: img, image: null });
        if (img === urlMain) setMainImg(i);
      } catch (error) {
        console.log(error);
        alert("Hay un error al cargar estas imágenes");
      }
    }
    setImg(newImgs);
  };

  const isWithSize = () => {
    if (
      category !== "barbijo" &&
      category !== "wallet" &&
      category !== "fragrance" &&
      category !== "accesory"
    )
      return true;
    return false;
  };

  const check = () => {
    if (isWithSize())
      if (sizes.length <= 0) {
        alert("Talles invalidos");
        return false;
      }
    if (img.length <= 0) {
      alert("Sube una imagen valida");
      return false;
    }
    if (price <= 0) {
      alert("Precio invalido");
      return false;
    }
    return true;
  };

  const uploadImg = async (_id, index) => {
    if (img[index].image !== null) {
      const file = img[index].image;
      const storageRef = firebase.storage().ref(`/pics/${_id}/${index}`);
      await storageRef.put(file);
    }
  };

  const deleteImgs = async (_id) => {
    for (var i = 0; i < cantImg; i++) {
      await deleteImg(_id, i);
    }
  };

  const deleteImg = async (_id, id_img) => {
    const storageRef = firebase.storage().ref(`/pics/${_id}/${id_img}`);
    await storageRef
      .delete()
      .then(function () {
        console.log("imagen borrada");
      })
      .catch(function (error) {
        alert(
          "No se encontró la imagen a reemplazar, puede seguir en en storage."
        );
      });
  };

  const uploadProduct = async (_id) => {
    const dbRef = firebase.database().ref("/products");
    for (var i = 0; i < img.length; i++) await uploadImg(_id, i);
    var imgMain = mainImg;
    if (imgMain > img.length) {
      alert(
        "La imagen principal no se asignó, por defecto se puso la primera."
      );
      imgMain = 0;
    }
    const urlImg = await firebase
      .storage()
      .ref(`pics/${_id}`)
      .child(`${imgMain}`)
      .getDownloadURL();
    const prd = dataProduct(_id, urlImg);
    const newProduct = await dbRef.push();
    await newProduct.set(prd);
  };

  const dataProduct = (_id, url) => {
    var sSizes = sizes;
    if (!isWithSize()) sSizes = null;
    const result = {
      _id,
      category,
      img: url,
      cantImg: img.length,
      price,
      sizes: sSizes,
      name,
    };
    return result;
  };

  const handleUploadProduct = async () => {
    if (!check()) return;
    setLoading("loading");
    const dbRef = firebase.database().ref("/products");
    try {
      const obj = await (await dbRef.limitToLast(1).once("value")).val();
      const _id = obj[Object.getOwnPropertyNames(obj)[0]]._id + 1;
      await uploadProduct(_id);
      setLoading("sucess");
    } catch (error) {
      try {
        dbRef.once("value").then(async (obj) => {
          if (!obj.exists()) {
            const _id = 1;
            await uploadProduct(_id);
            setLoading("sucess");
          }
        });
      } catch (error) {
        console.log(error);
        setLoading("error");
      }
    }
  };

  const imgsModify = async (id) => {
    if (img.length < cantImg) {
      for (var i = img.length; i < cantImg; i++) {
        await deleteImg(id, i);
      }
    }
    for (var ii = 0; ii < img.length; ii++) {
      if (img[ii].image !== null) await uploadImg(id, ii);
    }
  };

  const handleModifyProduct = async () => {
    if (!check()) return;
    setLoading("loading");
    const _id = parseInt(props.match.params.id);
    imgsModify(_id);
    var imgMain = mainImg;
    if (imgMain > img.length || imgMain < 0) {
      alert(
        "La imagen principal no se asignó, por defecto se puso la primera."
      );
      imgMain = 0;
    }
    var url = await firebase
      .storage()
      .ref(`pics/${_id}`)
      .child(`${imgMain}`)
      .getDownloadURL();
    const prd = dataProduct(_id, url);
    await firebase
      .database()
      .ref("/products/" + idBD)
      .set(prd, (err) => {
        if (err) {
          setLoading("error");
          console.log(err);
        } else setLoading("sucess");
      });
  };

  const handleDeleteProduct = async () => {
    if (window.confirm("¿Está seguro de eliminar este producto?")) {
      setLoading("loading");
      await deleteImgs(props.match.params.id);
      await firebase
        .database()
        .ref("/products/" + idBD)
        .remove()
        .then(function () {
          setLoading("sucess");
          console.log("Document successfully deleted!");
        })
        .catch(function (error) {
          setLoading("error");
          console.error("Error removing document: ", error);
        });
    }
  };

  const handleNewProduct = () => {
    defaultProps();
    props.match.params = {};
    setLoading("");
  };

  const handleDeleteImg = (i) => {
    if (props.match.params.id && i < img.length - 1) {
      alert("Al modificar imágenes sólo podes eliminar la última");
      return;
    }
    if (window.confirm("Esta seguro de eliminar esta imagen?")) {
      let newImgs = [];
      for (var im of img) if (img[i] !== im) newImgs.push(im);
      if (mainImg === i) setMainImg(0);
      setImg(newImgs);
    }
  };

  if (loading === "loading") return <div className="cargando"></div>;
  if (loading === "sucess" || loading === "error")
    return (
      <div className="content-sucess">
        <div>
          <Link className="button" to="/">
            Volver
          </Link>
        </div>
        <div>
          <button className="button" onClick={handleNewProduct}>
            Cargar prenda
          </button>
        </div>
        {loading === "sucess" ? (
          <p>Acción realizada con éxito.</p>
        ) : (
          <p className="error">
            Se ha producido un error al cargar el producto.
          </p>
        )}
      </div>
    );

  return (
    <div>
      <div>
        <Link className="button back" to="/">
          Volver
        </Link>
      </div>
      <h2>{props.match.params.id ? "Modificar Prenda" : "Añadir Prenda"}</h2>
      <div className="filters">
        <Selects
          handleChangeCategory={handleChangeCategory}
          category={category}
          handleChangeSizes={handleChangeSizes}
          sizes={sizes}
          multiple={true}
        />
      </div>
      <div>
        <label htmlFor="file-upload" className="button select-img">
          Agregar imágenes
        </label>
        <input
          type="file"
          id="file-upload"
          className="file"
          multiple
          onChange={handleChangeImage}
        />
      </div>
      <div className="products-upload">
        {img &&
          img.map((i, index) => (
            <img
              key={index}
              src={i.url}
              onClick={() =>
                index === mainImg ? handleDeleteImg(index) : setMainImg(index)
              }
              className={index === mainImg ? "img-product main" : "img-product"}
              alt="Imagen subida"
            />
          ))}
      </div>
      <div className="price">
        <span>Precio</span>
        <input type="number" value={price} onChange={handleChangePrice}></input>
      </div>
      <div className="price">
        <span>Nombre</span>
        <input type="text" value={name} onChange={handleChangeName}></input>
      </div>
      <div>
        {props.match.params.id ? (
          <div>
            <button onClick={handleModifyProduct} className="button upload">
              Modificar Producto
            </button>
            <br></br>
            <button onClick={handleDeleteProduct} className="button delete">
              Eliminar Producto
            </button>
          </div>
        ) : (
          <button onClick={handleUploadProduct} className="button upload">
            Subir Producto
          </button>
        )}
      </div>
    </div>
  );
}
